import gql from 'graphql-tag';

export const videoPostQuery = gql`
  query ($slug: ID!) {
    video(id: $slug, idType: SLUG) {
      categories {
        nodes {
          name
          slug
        }
      }
      content
      date
      duration
      embed
      excerpt
      pdf
      tags {
        nodes {
          name
          slug
        }
      }
      title
      transcript
    }
  }
`;
